











































































































import { Vue, Component } from 'vue-property-decorator'
import { getThumbUrl } from '@/utils/thumbnail'

const PY_OPTIONS = [
    { v: '45', t: '20평형' },
    { v: '46', t: '30평형' },
    { v: '47', t: '40평형' },
    { v: '48', t: '50평형~' }
]

interface FormData {
    name: string
    py: string
    description: string
}

interface FormErrors {
    name: string
    py: string
}

@Component
export default class ApartmentEdit extends Vue {
    pyOptions = PY_OPTIONS

    form: FormData = { name: '', py: '', description: '' }
    images: string[] = []
    errors: FormErrors = { name: '', py: '' }
    saveError = ''
    uploading = false
    saving = false
    getThumbUrl = getThumbUrl

    get isEdit (): boolean {
        return !!this.$route.query.id
    }

    get apartmentId (): string {
        return String(this.$route.query.id || '')
    }

    async created () {
        if (this.isEdit) {
            await this.loadApartment()
        }
    }

    async loadApartment () {
        try {
            const list: any[] = await this.$store.dispatch('adminApartmentList') || []
            const apt = list.find((a: any) => String(a.id) === this.apartmentId)
            if (apt) {
                this.form.name = apt.name || ''
                this.form.py = String(apt.py || '')
                this.form.description = apt.description || ''
                this.images = Array.isArray(apt.images) ? [...apt.images] : []
            }
        } catch (e) {
            // API unavailable — stay with empty form
        }
    }

    async onFilesChange (event: Event) {
        const input = event.target as HTMLInputElement
        if (!input.files || input.files.length === 0) return

        const files = Array.from(input.files)
        this.uploading = true
        try {
            const urls: string[] = await this.$store.dispatch('uploadApartmentPhotos', files)
            if (Array.isArray(urls)) {
                this.images = [...this.images, ...urls]
            }
        } catch (e) {
            this.saveError = '사진 업로드 중 오류가 발생했습니다.'
        } finally {
            this.uploading = false
            // Reset input so same files can be re-selected if needed
            if (this.$refs.fileInput) {
                (this.$refs.fileInput as HTMLInputElement).value = ''
            }
        }
    }

    removeImage (idx: number) {
        this.images.splice(idx, 1)
    }

    moveImage (from: number, to: number) {
        const arr = [...this.images]
        const item = arr.splice(from, 1)[0]
        arr.splice(to, 0, item)
        this.images = arr
    }

    validate (): boolean {
        this.errors = { name: '', py: '' }
        let valid = true
        if (!this.form.name.trim()) {
            this.errors.name = '이름을 입력해주세요.'
            valid = false
        }
        if (!this.form.py) {
            this.errors.py = '평형을 선택해주세요.'
            valid = false
        }
        return valid
    }

    async save () {
        this.saveError = ''
        if (!this.validate()) return
        if (this.uploading || this.saving) return

        this.saving = true
        try {
            const dto = {
                name: this.form.name.trim(),
                py: this.form.py,
                description: this.form.description.trim(),
                images: this.images
            }
            if (this.isEdit) {
                await this.$store.dispatch('updateApartment', { id: this.apartmentId, dto })
            } else {
                await this.$store.dispatch('createApartment', dto)
            }
            this.$router.push({ name: 'adminApartments' })
        } catch (e) {
            const err = e as any
            const msg = err?.response?.data?.message || err?.message || '저장 중 오류가 발생했습니다.'
            this.saveError = msg
        } finally {
            this.saving = false
        }
    }

    cancel () {
        this.$router.push({ name: 'adminApartments' })
    }
}
